import React, { useState, useRef } from "react";
import Event from "../../assets/images/event_service.png";
import Housekeeping from "../../assets/images/house_keeping_service.png";
import CorporateSecurity from "../../assets/images/corporate_service.png";
import MannedGuarding from "../../assets/images/MannedGuarding.png";
import DogGuarding from "../../assets/images/DogGuarding.png";
import SiteProtection from "../../assets/images/SiteProtection.png";
import Retail from "../../assets/images/retail_service.png";
import "./Cover3.scss";
import WhiteCover from "../WhiteCover/WhiteCover";

const Services = [
  {
    img: Event,
    description: ["Event, Festival ", "Security & Stewarding"],
    popupDescription:
      "At JJSS our Event & Festival Security teams specialize in managing crowds, ensuring smooth operations, and maintaining safety for events of every scale—from private gatherings to large outdoor festivals. We provide comprehensive services, including access control, ticket verification, bag checks, VIP protection, stage-front management, and rapid incident response. Our officers are trained in crowd control, emergency procedures, and conflict management to create a safe and enjoyable experience for all attendees. With careful planning, professional coordination, and proactive risk management, we ensure your event runs securely and successfully from start to finish.",
  },
  {
    img: CorporateSecurity,
    description: ["Corporate", "Security"],
    popupDescription:
      "At JJSS our Corporate Security services are designed to protect your business, employees, and assets while maintaining a professional and welcoming environment. We provide highly trained security officers skilled in access control, visitor management, emergency response, CCTV monitoring, and conflict de-escalation. Whether safeguarding office buildings, corporate headquarters, or business parks, we deliver a strategic security presence tailored to your operational needs. With a focus on risk prevention and fast incident resolution, we ensure your workplace remains secure, efficient, and fully compliant with safety standards.",
  },
  {
    img: Retail,
    description: ["Retail & Public", "Sector Security"],
    popupDescription:
      "At JJSS our Retail Security solutions help prevent theft, reduce shrinkage, and create a safe shopping experience for customers and staff. From uniformed retail guards and store detectives to loss-prevention specialists, our team is trained to identify suspicious behaviour, respond to incidents, and support daily store operations. We integrate security measures such as patrols, customer assistance, stock protection, and emergency handling to ensure smooth store performance. With a strong customer-service approach, our officers protect your brand while maintaining a positive retail environment.",
  },
  {
    img: Housekeeping,
    description: ["Housekeeping", "& cleaning"],
    popupDescription:
      "At JJSS we provide professional Housekeeping and Cleaning services that maintain cleanliness, hygiene, and a welcoming atmosphere within your premises. Our trained cleaning staff deliver reliable daily, weekly, or deep-cleaning solutions tailored to offices, commercial buildings, event venues, and residential complexes. Services include floor care, waste management, restroom sanitation, dusting, window cleaning, and specialized cleaning based on your needs. With quality control measures and environmentally friendly products, we ensure your space remains spotless, safe, and presentable at all times.",
  },
  {
    img: MannedGuarding,
    description: ["Manned Guarding"],
    popupDescription:
      "At JJSS our professional Manned Guarding service offers a visible and effective deterrent against crime. All our security officers are fully trained, licensed, and equipped to handle a wide range of security challenges. From access control and visitor management to emergency response and patrol duties, our guards deliver round-the-clock protection with professionalism and reliability. We tailor each deployment to your environment, ensuring that our team integrates seamlessly with your operations while maintaining a strong security presence.",
  },
  {
    img: DogGuarding,
    description: ["Dog Guarding"],
    popupDescription:
      "At JJSS our highly trained K-9 Units provide an enhanced level of detection and protection that exceeds the capabilities of human personnel alone. Our dogs are expertly trained in areas such as patrol, tracking, drug detection, and explosive detection. Working alongside our skilled handlers, they serve as a powerful deterrent to intruders and are invaluable for high-risk environments, large sites, and events requiring advanced security measures. The K-9 team's keen senses and rapid response capabilities significantly strengthen overall site security.",
  },
  {
    img: SiteProtection,
    description: ["Site Protection"],
    popupDescription:
      "At JJSS our Site Protection services are designed to safeguard your premises against unauthorized access, theft, vandalism, and potential threats. We implement a multi-layered security approach that combines advanced surveillance technology with strategic risk assessment to ensure continuous protection. Whether it's a construction site, commercial property, residential estate, or critical infrastructure, our team monitors and secures every vulnerable point. With real-time reporting, rapid incident response, and tailored security plans, we provide complete peace of mind and the highest level of site safety.",
  },
];

export default function Cover3() {
  const ServiceItem = ({ service }) => {
    const [open, setOpen] = useState(false);
    const [placement, setPlacement] = useState("top");
    const [modalPos, setModalPos] = useState({ left: 0, top: 0, width: 380 });
    const itemRef = useRef(null);
    const modalRef = useRef(null);

    return (
      <div
        ref={itemRef}
        className={`d-flex flex-dir-col white-main service-item ${
          open ? "open" : ""
        }`}
        onMouseEnter={() => {
          // open and compute position
          setOpen(true);
          // compute position in next frame once modal has rendered
          requestAnimationFrame(() => {
            const itemRect = itemRef.current?.getBoundingClientRect();
            const modalEl = modalRef.current;
            const modalW = modalEl ? modalEl.offsetWidth : 380;
            const modalH = modalEl ? modalEl.offsetHeight : 300;
            if (!itemRect) return;
            const spaceAbove = itemRect.top;
            const spaceBelow = window.innerHeight - itemRect.bottom;
            const prefer =
              spaceBelow >= modalH + 16
                ? "bottom"
                : spaceAbove >= modalH + 16
                  ? "top"
                  : spaceBelow >= spaceAbove
                    ? "bottom"
                    : "top";
            let left = itemRect.left + itemRect.width / 2 - modalW / 2;
            const margin = 8;
            left = Math.max(
              margin,
              Math.min(left, window.innerWidth - modalW - margin),
            );
            let top =
              prefer === "bottom"
                ? itemRect.bottom + 8
                : itemRect.top - modalH - 8;
            // if modal would still be off-screen vertically, clamp
            top = Math.max(8, Math.min(top, window.innerHeight - modalH - 8));
            setPlacement(prefer);
            setModalPos({ left, top, width: modalW });
          });
        }}
        onMouseLeave={() => setOpen(false)}
        onClick={() => {
          if (!open) {
            // open via click (mobile) and compute positions
            setOpen(true);
            requestAnimationFrame(() => {
              const itemRect = itemRef.current?.getBoundingClientRect();
              const modalEl = modalRef.current;
              const modalW = modalEl ? modalEl.offsetWidth : 380;
              const modalH = modalEl ? modalEl.offsetHeight : 300;
              if (!itemRect) return;
              const spaceAbove = itemRect.top;
              const spaceBelow = window.innerHeight - itemRect.bottom;
              const prefer =
                spaceBelow >= modalH + 16
                  ? "bottom"
                  : spaceAbove >= modalH + 16
                    ? "top"
                    : spaceBelow >= spaceAbove
                      ? "bottom"
                      : "top";
              let left = itemRect.left + itemRect.width / 2 - modalW / 2;
              const margin = 8;
              left = Math.max(
                margin,
                Math.min(left, window.innerWidth - modalW - margin),
              );
              let top =
                prefer === "bottom"
                  ? itemRect.bottom + 8
                  : itemRect.top - modalH - 8;
              top = Math.max(8, Math.min(top, window.innerHeight - modalH - 8));
              setPlacement(prefer);
              setModalPos({ left, top, width: modalW });
            });
          } else {
            setOpen(false);
          }
        }}
      >
        <div className="text-align-center mt-2">
          <img src={service?.img} alt="Service" height={75} />
        </div>
        <div className="d-flex flex-dir-col">
          {service?.description?.map((item, i) => (
            <span
              key={`item-${i}`}
              className="text-align-center mt-2 h3-sb title"
            >
              {item}
            </span>
          ))}
        </div>

        {/* Hover/click modal */}
        <div
          ref={modalRef}
          className={`service-hover-modal ${
            placement === "bottom" ? "placement-bottom" : "placement-top"
          }`}
          role="dialog"
          aria-hidden={!open}
          onClick={(e) => e.stopPropagation()}
          style={
            open
              ? {
                  position: "fixed",
                  left: Math.round(modalPos.left),
                  top: Math.round(modalPos.top),
                  width: modalPos.width,
                }
              : undefined
          }
        >
          <div className="modal-inner">
            <div className="modal-img text-align-center">
              <img src={service?.img} alt="Service large" height={100} />
            </div>
            <div className="modal-title">
              {service?.description?.map((d, idx) => (
                <span
                  key={`desc-${idx}`}
                  className="h4-sb"
                >
                  {d}
                </span>
              ))}
            </div>
            {service?.popupDescription && (
              <div className="modal-desc">
                <p>{service.popupDescription}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <WhiteCover className={"d-flex flex-dir-col pb-70"}>
      <p className="h1-sb white-main text-align-center">
        The Services we provide!
      </p>
      <div className="d-flex services">
        {Services?.map((service, i) => (
          <ServiceItem key={`service-${i}`} service={service} />
        ))}
      </div>
    </WhiteCover>
  );
}
